var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.43964 14.2104L15.3752 8.27485C15.8234 7.82664 15.8234 7.09994 15.3752 6.65173C14.9269 6.20351 14.2002 6.20351 13.752 6.65173L8.02543 12.3783L6.2464 10.5993C5.79818 10.1511 5.07148 10.1511 4.62327 10.5993C4.17506 11.0475 4.17506 11.7742 4.62327 12.2224L6.61121 14.2104C6.98391 14.5831 7.46711 14.7779 7.95535 14.7949L8.0254 14.865L8.09545 14.7949C8.58371 14.7779 9.06693 14.5831 9.43964 14.2104Z",
    fill: "#FAF9F7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkmark.0582a2deb57e6e35745a6ad6be9b9a06.svg";